import moment from 'moment';
import Abstract from './Abstract.js';

export default class RowMilestonesMarker extends Abstract {
  constructor(props) {
    super(props);
    this.marker = null;
    this.markerWidth = 24;
    this.text = null;
  }

  build() {
    const { chart, data, options } = this.props;

    if (options.showMilestones) {
      const group = chart
        .selectAll('svg')
        .data(
          data.milestonesFromAllCharts.map((mile) => {
            const startDate = moment(mile.date_at).set({
              hour: 0,
              minute: 0,
              second: 0,
              millisecond: 0,
            });

            const endDate = moment(mile.date_at).set({
              hour: 23,
              minute: 59,
              second: 59,
              millisecond: 999,
            });
            return {
              ...mile,
              title: null,
              startDate,
              endDate,
            };
          })
        )
        .enter()
        .append('g')
        .attr('class', 'mile-count group-mile');

      this.marker = group
        .append('rect')
        .attr('class', 'mile portfolio modal-mile ')
        .attr('rx', 8)
        .attr('ry', 8)
        .attr('cursor', 'pointer')
        .attr('height', 14)
        .attr('width', this.markerWidth)
        .attr('x', (d) => this.getVisibleStartX(d))
        .attr('y', 5);

      this.line = group
        .append('rect')
        .attr('class', 'mile portfolio')
        .attr('width', 2)
        .attr('x', (d) => this.getLineVisibleStartX(d))
        .attr('y', 18)
        .attr('height', 8);

      this.text = group
        .append('text')
        .text((d) => d.childMilestone.length)
        .attr('class', 'modal-mile')
        .style('fill', 'white')
        .style('font-size', '12px')
        .attr('dominant-baseline', 'central')
        .attr('cursor', 'pointer')
        .attr('x', '50%')
        .attr('y', '50%')
        .attr('x', (d) => this.getTextVisibleStartX(d))
        .attr('y', 12)
        .attr('opacity', (d) => (this.isLabelOverflowing(d) ? 0 : 1));
    }
  }

  update() {
    const { options } = this.props;

    if (options.showMilestones) {
      this.marker
        .transition()
        .duration(this.transitionDuration)
        .attr('x', (d) => this.getVisibleStartX(d));
      this.line
        .transition()
        .duration(this.transitionDuration)
        .attr('x', (d) => this.getLineVisibleStartX(d));
      this.text
        .transition()
        .duration(this.transitionDuration)
        .attr('x', (d) => this.getTextVisibleStartX(d));
    }
  }

  getStartX(datum) {
    return this.xScale(datum.startDate);
  }

  getEndX(datum) {
    return this.xScale(datum.endDate);
  }

  getVisibleStartX(datum) {
    return (
      this.getStartX(datum) + (this.getWidth(datum) - this.markerWidth) / 2
    );
  }

  getLineVisibleStartX(datum) {
    return this.getStartX(datum) + (this.getWidth(datum) - 2) / 2;
  }

  getTextVisibleStartX(datum) {
    const textWidth = this.getEstimatedTextWidth(
      String(datum.childMilestone.length)
    );
    const shift = (this.markerWidth - textWidth) / 2 - 1;
    return (
      this.getStartX(datum) +
      (this.getWidth(datum) - this.markerWidth) / 2 +
      shift
    );
  }

  getVisibleEndX(datum) {
    return Math.min(this.rangeEnd, this.getEndX(datum));
  }

  getWidth(datum) {
    return this.getEndX(datum) - this.getStartX(datum);
  }

  getVisibleWidth(datum) {
    return this.getVisibleEndX(datum) - this.getVisibleStartX(datum);
  }

  getEstimatedTextWidth(datum) {
    return datum.length * 6;
  }

  isLabelOverflowing(datum) {
    return this.getEstimatedTextWidth(datum) > this.getVisibleWidth(datum);
  }
}
